import networkApi from './network.api'
export function getAllLineDirectionIdsFromTrips(trips) {
  const lineDirectionIdSet = new Set()
  trips.forEach((trip) => {
    lineDirectionIdSet.add(trip.lineDirection.id)
  })
  return Array.from(lineDirectionIdSet).filter(Boolean)
}

export function groupBy(arr, prop) {
  return arr.reduce((result, obj) => {
    const key = obj[prop].toString()
    result[key] = obj
    return result
  }, {})
}

export async function enrichTripsLineDirections(trips, date) {
  const lineDirectionIds = getAllLineDirectionIdsFromTrips(trips)

  const enrichedLineDirections = await networkApi.getMultipleLineDirections(
    lineDirectionIds,
    date,
  )
  const enrichedLineDirectionsById = groupBy(enrichedLineDirections, 'id')

  return trips
    .map((trip) => ({
      ...trip,
      lineDirection: enrichedLineDirectionsById[trip.lineDirection.id],
    }))
    .filter((trip) => trip.lineDirection !== undefined)
}
